import React from 'react';
import { Button } from 'components/quashed';
import TextInput from './TextInput';
import styles from './styles/TextInput.module.scss';
import { IFormFieldProps } from './common';

const RegoInput = (
  {
    className,
    inputWrapClassName,
    ...props
  }: IFormFieldProps & React.HTMLProps<HTMLInputElement>,
  ref,
) => {
  const showButton = !props.formValues?.vehicleInfoError && props.showButton;
  const hideNoRegoButton = props.hideNoRegoButton;

  return (
    <TextInput
      ref={ref}
      {...props}
      showButton={showButton}
      buttonDisabled={!props.value?.trim()}
      className={classnames(styles.rego, className)}
      inputWrapClassName={classnames(styles.inputWrap, inputWrapClassName)}
      required={props.formValues?.vehicleInfoError}
    >
      {showButton && !hideNoRegoButton && (
        <Button
          id="noRego"
          className={styles.noRegoBtn}
          inverted={true}
          type="button"
          onClick={props.onButtonClick}
        >
          I don’t have a number plate
        </Button>
      )}
    </TextInput>
  );
};

export default React.forwardRef(RegoInput);
